import React, { useEffect, useState } from 'react'
import { AddlYTLink, getInitialYTLink } from '../../Services/allApi'
import { Icon } from '@iconify/react/dist/iconify.js'
import { toast } from 'react-toastify'

function YoutubeLinkAdd({mapId,close,setIsEdited}) {
  const [ytLink,setYtLink]=useState()
  useEffect(()=>{
    if(mapId){
      getInitilaYtLink()
    }
  },[mapId])

  const getInitilaYtLink=async()=>{
    const token = sessionStorage.getItem('access_token')
        const reqHeader = {
            "Content-Type": "application/json",
            "Authorization": `${token}`
        };
    const res= await getInitialYTLink(reqHeader,mapId)
    console.log(res);
   if(res?.data){
    setYtLink(res?.data[0]?.video_link)
   }
    
  }
  const handleSubmit=async()=>{
    const token = sessionStorage.getItem('access_token')
        const reqHeader = {
            "Content-Type": "application/json",
            "Authorization": `${token}`
        };
const dataToApi={video_id:mapId,video_link:ytLink}
    const res= await AddlYTLink(dataToApi,reqHeader)
    console.log(res);
    
    if(res.status==200){
      toast.success("Youtube link added successfully")
      close()
      setIsEdited(205)
    }else{
        const messageData = res?.response?.data?.message;
        // Check if messageData is an object
        const errorMessage = typeof messageData === 'object' && messageData !== null
            ? messageData[Object.keys(messageData)?.[0]]?.[0] // Get the first message from the object
            : messageData; // If it's a string, use it directly
        toast.error(errorMessage ?? "There was a problem adding youtube link");
      // toast.error(res?.response?.data?.message??"There was a problem adding youtube link")
    }
    
  }
  return (
    <>
    <div className='flex flex-col items-center justify-center w-full ' style={{ fontFamily: 'ropa sans' }}>
                <div className='flex justify-end items-start w-full pb-1'><div onClick={close} className='flex justify-center items-center h-10 w-10 border-l border-b border-red-500 hover:bg-red-500 hover:text-white transform duration-500 ease-in-out cursor-pointer text-red-500'><Icon icon="iconamoon:close" className='text-2xl' /></div></div>

                        {/* <p className='text-blue-500'>Video Id: {dataToEdit?.video_id}</p> */}

                        <div className='w-10/12 flex flex-col mt-2 mb-14'>
                            <label htmlFor="field3">Update Youtube Link</label>
                            <input
                                id='field3'
                                value={ytLink}
                                onChange={(e) => setYtLink(e.target.value)}
                                type="text"
                                className='bg-success w-full h-10 rounded-lg border border-dashed border-gray-700 px-2'
                            />
                        </div>

                        {/* End of additional fields */}
                        {ytLink&&<div className='flex flex-row justify-center mb-5'>
                            <button className='px-10 py-2 bg-green-600 text-white rounded me-2' onClick={handleSubmit}>Submit</button>
                            {/* <button className='px-4 py-2 bg-success rounded-full ms-2' onClick={close}>Cancel</button> */}
                        </div>}
                    </div>
                    </>
  )
}

export default YoutubeLinkAdd